module.exports = __webpack_public_path__ + "img/disgust.9ffef484.jpg";